import React, { useState } from 'react';
import { Modal, Box, Button, Typography, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FilePresentIcon from '@mui/icons-material/FilePresent';

const ImportFormsModal = ({ open, handleClose, submitJsonFile }) => {
  const [fileContent, setFileContent] = useState(null);
  const [fileName, setFileName] = useState(null);

  // Function to handle file upload and ensure it's a JSON file
  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file && file.type === "application/json") {
      const reader = new FileReader();
      reader.onload = function(e) {
        try {
          const json = JSON.parse(e.target.result); // Parse the JSON file
          setFileContent(json);
          setFileName(file.name);
        } catch (error) {
          console.error("Error parsing JSON file", error);
          alert("Invalid JSON file.");
        }
      };
      reader.readAsText(file); // Read the file as text
    } else {
      alert("Please upload a valid JSON file.");
    }
  };

  const handleSubmit = () => {
    if (fileContent) {
      submitJsonFile(fileContent); // Pass the JSON content to the parent component
    } else {
      alert("No file uploaded or file format is incorrect.");
    }
  };

  const handleCancel = () => {
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleCancel}
      aria-labelledby="import-forms-modal-title"
      aria-describedby="import-forms-modal-description"
    >
      <Box 
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          width: 350,
          borderRadius: 2,
          outline: 'none',
        }}
      >
        {/* Close Button */}
        <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" sx={{ mb: 1 }}>
          Select File
        </Typography>
        <hr />

        {/* Display File Name with Icon */}
        {fileName && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f5f5f5',
              borderRadius: 1,
              p: 1,
              mt: 2,
              cursor: 'pointer'
            }}
          >
            <FilePresentIcon sx={{ mr: 1, color: 'var(--app-color)' , fontSize: 35}} />
            <Tooltip title={fileName} arrow>
              <Typography 
                variant="body2" 
                sx={{
                  maxWidth: '250px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                {fileName.length > 25 ? `${fileName.substring(0, 25)}...` : fileName}
              </Typography>
            </Tooltip>
          </Box>
        )}

        {/* Upload Button */}
        <Button
          component="label"
          sx={{
            mt: 2,
            width: '100%',
            backgroundColor: 'var(--button-color)',
            color: 'white',
            fontWeight: 'normal',
            textTransform: 'none',
            ":hover": {
              backgroundColor: 'var(--button-hover-color)',
            },
          }}
        >
          Upload JSON
          <input
            type="file"
            accept=".json"
            onChange={handleFileUpload}
            hidden
          />
        </Button>

        {/* Conditionally show the submit button when a file is loaded */}
        {fileContent && (
          <>
            <Button
              onClick={handleSubmit}
              sx={{
                mt: 2,
                width: '100%',
                backgroundColor: 'var(--button-color)',
                color: 'white',
                fontWeight: 'normal',
                textTransform: 'none',
                ":hover": {
                  backgroundColor: 'var(--button-hover-color)',
                },
              }}
            >
              Submit
            </Button>
          </>
        )}

        <Button
          variant="outlined"
          onClick={handleCancel}
          sx={{
            mt: 2,
            width: '100%',
            color: 'var(--button-color)',
            backgroundColor: 'transparent',
            borderColor: 'var(--button-color)',
            textTransform: 'none',
            ":hover": {
              borderColor: 'var(--button-color)',
            },
          }}
        >
          Cancel
        </Button>
      </Box>
    </Modal>
  );
};

export default ImportFormsModal;